module.exports = __webpack_public_path__ + "img/IMG_9321_L_BlackMatted.b0dd8652.jpg";